export const questionTypes = [
  {
    value: 'risk',
    label: 'What happens when I improve detection or management of key CVD risk factors?'
  }, {
    value: 'intervention',
    label: 'What happens when I improve usage of the key interventions for people at risk of CVD?'
  }
]
